// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}
/* standard for all popups */
.action_container {
  text-align: right;
  margin-top: 20px;
}

.btn_confirm {
  font-weight: bold !important;
  color: var(--color-theme-blue) !important;
  width: 150px;
  margin-left: 15px !important;
  border: 1px solid var(--color-theme-blue) !important;
}

.btn_confirm:disabled {
  color: var(--color-theme-deactivated) !important;
  border: 1px solid var(--color-theme-deactivated) !important;
  cursor: not-allowed !important;
}

.btn_cancel {
  font-weight: bold !important;
  width: 150px;
  color: var(--color-font-red) !important;
  border: 1px solid var(--color-theme-red) !important;
}

.btn_activate {
  font-weight: bold !important;
  width: 150px;
  margin-left: 15px !important;
  color: var(--color-theme-blue) !important;
  border: 1px solid var(--color-theme-blue) !important;
}
/* standard for all popups */
.MuiFormLabel-asterisk.MuiInputLabel-asterisk {
  color: red !important;
}

/* Change color of MUI Checkbox for all checkboxes */
:global(.MuiCheckbox-root.Mui-checked) {
  color: var(--color-theme-blue) !important;
}

.input[type="date"]::-webkit-calendar-picker-indicator {
  color: black;
  background-color: yellow;
  border: solid;
  border-color: pink;
}

.btn_disabled {
  color: rgba(0, 0, 0, 0.26) !important;
  border-color: rgba(0, 0, 0, 0.26) !important;
  cursor: default;
  pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;AACA,4BAA4B;AAC5B;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,yCAAyC;EACzC,YAAY;EACZ,4BAA4B;EAC5B,oDAAoD;AACtD;;AAEA;EACE,gDAAgD;EAChD,2DAA2D;EAC3D,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,uCAAuC;EACvC,mDAAmD;AACrD;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,4BAA4B;EAC5B,yCAAyC;EACzC,oDAAoD;AACtD;AACA,4BAA4B;AAC5B;EACE,qBAAqB;AACvB;;AAEA,oDAAoD;AACpD;EACE,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,wBAAwB;EACxB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,4CAA4C;EAC5C,eAAe;EACf,oBAAoB;AACtB","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\n    \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n/* standard for all popups */\n.action_container {\n  text-align: right;\n  margin-top: 20px;\n}\n\n.btn_confirm {\n  font-weight: bold !important;\n  color: var(--color-theme-blue) !important;\n  width: 150px;\n  margin-left: 15px !important;\n  border: 1px solid var(--color-theme-blue) !important;\n}\n\n.btn_confirm:disabled {\n  color: var(--color-theme-deactivated) !important;\n  border: 1px solid var(--color-theme-deactivated) !important;\n  cursor: not-allowed !important;\n}\n\n.btn_cancel {\n  font-weight: bold !important;\n  width: 150px;\n  color: var(--color-font-red) !important;\n  border: 1px solid var(--color-theme-red) !important;\n}\n\n.btn_activate {\n  font-weight: bold !important;\n  width: 150px;\n  margin-left: 15px !important;\n  color: var(--color-theme-blue) !important;\n  border: 1px solid var(--color-theme-blue) !important;\n}\n/* standard for all popups */\n.MuiFormLabel-asterisk.MuiInputLabel-asterisk {\n  color: red !important;\n}\n\n/* Change color of MUI Checkbox for all checkboxes */\n:global(.MuiCheckbox-root.Mui-checked) {\n  color: var(--color-theme-blue) !important;\n}\n\n.input[type=\"date\"]::-webkit-calendar-picker-indicator {\n  color: black;\n  background-color: yellow;\n  border: solid;\n  border-color: pink;\n}\n\n.btn_disabled {\n  color: rgba(0, 0, 0, 0.26) !important;\n  border-color: rgba(0, 0, 0, 0.26) !important;\n  cursor: default;\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
